import { render, staticRenderFns } from "./taskItemWidget.vue?vue&type=template&id=2d73358f&scoped=true"
import script from "./taskItemWidget.vue?vue&type=script&lang=js"
export * from "./taskItemWidget.vue?vue&type=script&lang=js"
import style0 from "./taskItemWidget.vue?vue&type=style&index=0&id=2d73358f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d73358f",
  null
  
)

export default component.exports